import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { name: 'Command Center', path: '/command-center-dashboard' },
    { name: 'Conservation Map', path: '/interactive-conservation-map' },
    { name: 'Visitor Planning', path: '/visitor-planning-hub' },
    { name: 'Research Portal', path: '/research-data-portal' }
  ];

  const communityLinks = [
    { name: 'Volunteer Opportunities', path: '/community-engagement-platform' },
    { name: 'Community Stories', path: '/community-engagement-platform' },
    { name: 'Cultural Heritage', path: '/community-engagement-platform' },
    { name: 'Economic Programs', path: '/community-engagement-platform' }
  ];

  const contactInfo = [
    { icon: 'MapPin', text: 'Puerto Princesa City, Palawan, Philippines' },
    { icon: 'Phone', text: '+63 (48) 434-4191' },
    { icon: 'Mail', text: 'info@ppsrnp.gov.ph' },
    { icon: 'Globe', text: 'www.ppsrnp.gov.ph' }
  ];

  const socialLinks = [
    { icon: 'Facebook', url: '#', label: 'Facebook' },
    { icon: 'Twitter', url: '#', label: 'Twitter' },
    { icon: 'Instagram', url: '#', label: 'Instagram' },
    { icon: 'Youtube', url: '#', label: 'YouTube' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">PPSRNP Digital Platform</h3>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              The Digital Guardian of Paradise - Protecting UNESCO World Heritage biodiversity through community-powered conservation and sustainable engagement.
            </p>
            <div className="flex gap-3">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  aria-label={social?.label}
                  className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary transition-colors group"
                >
                  <Icon name={social?.icon} size={18} className="text-gray-400 group-hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-gray-400 hover:text-accent transition-colors text-sm flex items-center gap-2"
                  >
                    <Icon name="ChevronRight" size={14} />
                    {link?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Community</h4>
            <ul className="space-y-2">
              {communityLinks?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-gray-400 hover:text-accent transition-colors text-sm flex items-center gap-2"
                  >
                    <Icon name="ChevronRight" size={14} />
                    {link?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              {contactInfo?.map((info, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Icon name={info?.icon} size={16} className="text-accent mt-0.5 flex-shrink-0" />
                  <span className="text-gray-400 text-sm">{info?.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Certifications & Partners */}
        <div className="border-t border-border pt-8 mb-8">
          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Icon name="Award" size={18} className="text-accent" />
              <span>UNESCO World Heritage Site</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Icon name="Shield" size={18} className="text-success" />
              <span>Philippine Government Protected Area</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Icon name="Leaf" size={18} className="text-primary" />
              <span>IUCN Category II National Park</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Puerto Princesa Subterranean River National Park. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-accent transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;